import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter, Route, Switch} from 'react-router-dom';
import {createBrowserHistory} from 'history';

// Styles
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
  // Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import '../scss/style.scss'

// Containers
import Login from './views/Pages/Login/'
import Full from './containers/Full/'

const history = createBrowserHistory();

//AsyncStorage.setItem('userData_key', 'userData_value').then((userData) =>{
//    this.setState({ userData: userData })
//})

ReactDOM.render((
  <HashRouter history={history}>
    <Switch>
      <Route path="/loanDetails/:id" name="Loan Application Details" component={Full}/>
      {/*<Route path="/generateInvoice" name="Generate Invoice" component={Full}/> */}
      <Route path="/createLoan" name="Create Loan Application" component={Full}/>
      <Route exact path="/dashboard" name="Dashboard" component={Full}/>
      <Route exact path="/partnerDashboard" name="partnerDashboard" component={Full}/>
      <Route exact path="/DSAReports" name="DSAReports" component={Full}/>
      <Route exact path="/InternalDsaSales" name="InternalDsaSales" component={Full}/>
      <Route path="/" name="Home" component={Login}/>
    </Switch>
  </HashRouter>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js